import { render, staticRenderFns } from "./GlimpsesLayout.vue?vue&type=template&id=27d770fb&"
import script from "./GlimpsesLayout.vue?vue&type=script&lang=js&"
export * from "./GlimpsesLayout.vue?vue&type=script&lang=js&"
import style0 from "./GlimpsesLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports